<template>
  <div class="default-form-controls">
      <div class="control control-delete btn-mobile-full" v-if="isDelete">
        <button
          type="button"
          class="btn btn-control btn-no-border red btn-control-delete btn-size-s btn-mobile-full"
          @click.prevent="handleCommand('delete')">
          <i class="el-icon-delete"></i>
        </button>
      </div>
      <div class="control control-back btn-mobile-full" v-if="isBack">
        <button
          type="button"
          class="btn btn-control btn-border grey btn-size-s btn-mobile-full"
          @click.prevent="handleCommand('back')"
          v-html="L10n('back')"/>
      </div>
      <div class="control control-copy btn-mobile-full" v-if="isClipboard">
        <button-clipboard
          class="btn btn-control btn-border blue btn-control-link btn-size-s btn-mobile-full"
          :options="{icon: 'el-icon-link'}"
          :disabled="isDisabledClipboard"
        />
      </div>
      <div class="control control-cancel btn-mobile-full" v-if="isCancel">
        <button
          type="button"
          class="btn btn-control btn-border grey btn-size-s btn-mobile-full"
          @click.prevent="handleCommand('cancel')"
          v-html="L10n('cancel')"/>
      </div>
      <div class="control control-create-edit btn-mobile-full" v-if="isSaveEdit">
        <button
          type="button"
          class="btn btn-control fill-dark-green btn-size-s btn-mobile-full"
          @click.prevent="handleCommand('save_edit')"
          v-html="L10n('create-and-continue')"/>
      </div>
      <div class="control control-save btn-mobile-full" v-if="isSave">
        <button
          type="button"
          class="btn btn-control btn-size-s btn-mobile-full"
          @click.prevent="handleCommand('save')"
          v-html="L10n('save')"/>
      </div>
      <div class="control control-create btn-mobile-full" v-if="isCreate">
        <button
          type="button"
          class="btn btn-control btn-size-s btn-mobile-full"
          @click.prevent="handleCommand('save')"
          v-html="L10n('create')"/>
      </div>
      <slot/>
  </div>
</template>

<script>
export default {
  name: 'FormControls',
  props: {
    isClipboard: { type: Boolean, default: false },
    isCancel: { type: Boolean, default: false },
    isBack: { type: Boolean, default: false },
    isCreate: { type: Boolean, default: false },
    isSave: { type: Boolean, default: false },
    isSaveEdit: { type: Boolean, default: false },
    isDelete: { type: Boolean, default: false },
    // :TODO Disabled
    isDisabledClipboard: { type: Boolean, default: false }
  },
  methods: {
    handleCommand (Command) {
      this.$emit('command', Command)
    }
  }
}
</script>

<style lang="stylus">
  .default-form-controls{
    display flex
    padding 1rem 0 0
    flex-wrap wrap
    align-items center
    justify-content flex-end
    .icon-db {
      vertical-align: middle;
      width: 2rem;
      height: 2rem;
      position: relative;
    }
    .control {
      > button {
        margin 0 .3rem
      }
      &-delete{
        order 1
        margin-right auto
      }
      &-back{
        order 2
      }
      &-copy {
        order 3
      }
      &-cancel{
        order 4
      }
      &-create-edit{
        order 5
      }
      &-save{
        order 6
      }
      &-create{
        order 7
      }
    }
  }
  .btn-control-link{
    &.btn{
      &.btn-border{
        &.is-disabled{
          color grey
          border-color grey
         }
      }
    }
  }
  .btn-control-delete{
    &.btn{
      &.btn-size-s{
        min-width 6rem
      }
    }
  }
</style>
